module.exports = __webpack_public_path__ + "img/cover-roger-meesters.aff4ebba.png";